import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { localize } from "@gtmhub/localization";
import { DestroyService } from "@webapp/core/util/services/destroy.service";

@Component({
  selector: "custom-field-number-input-field",
  templateUrl: "./number-input-field.component.html",
  styleUrls: ["./number-input-field.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DestroyService],
})
export class CustomFieldNumberInputFieldComponent implements OnInit {
  @Input() public uiId: string;
  @Input() public errorMessageId?: string;
  @Input() public selected: number;
  @Input() public placeholder = "";
  @Input() public disabled: boolean;
  @Input() public a11yLabel: string;
  @Input() public a11yLabelledby: string;
  @Input() public a11yDescription: string;
  @Input() public a11yRequired: boolean;
  @Input() public max = 9_999_999_999;
  @Input() public e2eTestId: string;
  @Input() public uiBorderless = true;
  @Input() public formatting: {
    prefix?: string;
    suffix?: string;
    precision?: number;
  };

  @Output() public readonly selectedChange = new EventEmitter<number>();
  @Output() public readonly inputBlur = new EventEmitter<void>();

  public ngOnInit(): void {
    this.generateA11yDescription();
  }

  private generateA11yDescription(): void {
    if (this.a11yDescription) {
      const description = this.a11yDescription.split(" ").reduce((descriptionArray, descriptionString) => {
        descriptionArray.push(localize(descriptionString));
        return descriptionArray;
      }, []);

      this.a11yDescription = description.join(" ");
    }
  }
}
